import experiments from 'experiment';
import type { ComponentEditorMetaDataDefinition } from '../types';

const isDeprecated = () => experiments.isOpen('se_editorDeprecationOverlay');

const metaData: ComponentEditorMetaDataDefinition = {
  deprecated: isDeprecated(),
};

export default metaData;
